module.exports = __webpack_public_path__ + "assets/img/Leo.3434a2e9.png";